export default __webpack_public_path__ + "static/media/netzstrom_oli.9decfa0f.svg";